export const DIVISION_KINDS = {
    EXTERNAL: 'EXTERNAL',
    INTERNAL: 'INTERNAL',
} as const;

export type DIVISION_KIND = (typeof DIVISION_KINDS)[keyof typeof DIVISION_KINDS];

export const DIVISION_ERRORS = {
    ID_TAKEN: 'DIVISION_ID_TAKEN',
    PHONE_NUMBER_ID_UNKNOWN: 'DIVISION_PHONE_NUMBER_ID_UNKNOWN',
} as const;
